import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    Grid,
    Typography,
    Box,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
    Checkbox,
    Chip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from '../../../../lib/axios';
import { getShiftMasterdropdata } from '../../../../Api/PropertyMst/Api';
import { toast } from 'react-toastify';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';

const AttendenceCalender = ({ open, onClose, dropdownData, userId }) => {
    const [calendarData, setCalendarData] = useState({
        Property: '',
        Month: '',
        Year: new Date().getFullYear().toString(),
        Shift: [],
    });
    const [calendarResults, setCalendarResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasData, setHasData] = useState(false);
    const [shiftData, setShiftData] = useState([]);
    const [selectedShifts, setSelectedShifts] = useState([]);
    const globalProperty = useSelector(selectGlobalProperty);

      useEffect(() => {
            if (globalProperty && globalProperty !== calendarData.Property) {
                setCalendarData(prevState => ({
                    ...prevState,
                    Property: globalProperty.toString()
                }));
            }
        }, [globalProperty]);

    const monthOptions = [
        { id: '1', name: 'January' },
        { id: '2', name: 'February' },
        { id: '3', name: 'March' },
        { id: '4', name: 'April' },
        { id: '5', name: 'May' },
        { id: '6', name: 'June' },
        { id: '7', name: 'July' },
        { id: '8', name: 'August' },
        { id: '9', name: 'September' },
        { id: '10', name: 'October' },
        { id: '11', name: 'November' },
        { id: '12', name: 'December' }
    ];
    useEffect(() => {
        if (open && dropdownData.length > 0) {
            const currentMonth = (new Date().getMonth() + 1).toString();
            setCalendarData(prev => ({
                ...prev,
                // Property: dropdownData[0].id,
                Month: currentMonth
            }));
        }
    }, [open]);
   const currentYear = new Date().getFullYear();
const yearOptions = [
    { id: (currentYear - 1).toString(), name: (currentYear - 1).toString() },
    { id: currentYear.toString(), name: currentYear.toString() },
    { id: (currentYear + 1).toString(), name: (currentYear + 1).toString() }
];

    useEffect(() => {
    if (open && dropdownData.length > 0) {
        const currentMonth = (new Date().getMonth() + 1).toString();
        setCalendarData(prev => ({
            ...prev,
            Month: currentMonth,
            Year: currentYear.toString() // Set current year as default
        }));
    }
}, [open]);

    const handleCalendarInputChange = (event) => {
        const { name, value } = event.target;
        setCalendarData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleShiftChange = (event) => {
        const { value } = event.target;
        setSelectedShifts(value);
        setCalendarData(prevState => ({
            ...prevState,
            Shift: value
        }));
    };

    const getMonthName = (monthId) => {
        const month = monthOptions.find(m => m.id === monthId);
        return month ? month.name : '';
    };

    const handleGetCalendarData = async () => {
        if (!calendarData.Property || !calendarData.Month || !calendarData.Year) {
            toast.error('Please select Property, Month and Year');
            return;
        }

        if (selectedShifts.length === 0) {
            toast.error('Please select at least one shift');
            return;
        }

        setIsLoading(true);
        try {
            const monthName = getMonthName(calendarData.Month);

            const allPromises = selectedShifts.map(shiftId =>
                axiosInstance.post('HkTargetCalendar/GetHkTargetCalendar', {
                    PropId: calendarData.Property,
                    MonthNm: monthName,
                    YearNm: calendarData.Year,
                    ShiftId: shiftId,
                    Flag: "T"
                })
            );

            const responses = await Promise.all(allPromises);
            const allData = [];
            responses.forEach((response, index) => {
                if (response.data.Status === 0 && response.data.Data) {
                    const shiftDataWithShiftInfo = response.data.Data.map(item => ({
                        ...item,
                        displayShiftId: selectedShifts[index],
                        displayShiftName: shiftData.find(shift => shift.id === selectedShifts[index])?.name || `Shift ${selectedShifts[index]}`
                    }));
                    allData.push(...shiftDataWithShiftInfo);
                }
            });

            if (allData.length > 0) {
                setCalendarResults(allData);
                setHasData(true);
            } else {
                toast.error('No data found for selected shifts');
                setCalendarResults([]);
                setHasData(false);
            }
        } catch (error) {
            console.error('Error fetching calendar data:', error);
            toast.error('Error fetching calendar data. Please try again.');
            setCalendarResults([]);
            setHasData(false);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        const fetchShiftData = async () => {
            try {
                const response = await getShiftMasterdropdata();
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.ShiftId,
                        name: item.ShiftName,
                    }));
                    setShiftData(dropdownItems);
                    if (dropdownItems.length > 0) {
                        setSelectedShifts([dropdownItems[0].id]);
                        setCalendarData(prev => ({
                            ...prev,
                            Shift: [dropdownItems[0].id]
                        }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching shift data");
            }
        };
        fetchShiftData();
    }, []);

    const handleReset = () => {
        setCalendarData({
            Property: globalProperty,
            Month: (new Date().getMonth() + 1).toString(),
            Year: new Date().getFullYear().toString(),
            Shift: shiftData.length > 0 ? [shiftData[0].id] : []
        });
        setSelectedShifts(shiftData.length > 0 ? [shiftData[0].id] : []);
        setCalendarResults([]);
        setHasData(false);
    };

    const handleClose = () => {
        setCalendarData({
            Property: globalProperty ,
            Month: (new Date().getMonth() + 1).toString(),
            Year: new Date().getFullYear().toString(),
            Shift: shiftData.length > 0 ? [shiftData[0].id] : []
        });
        setSelectedShifts(shiftData.length > 0 ? [shiftData[0].id] : []);
        setCalendarResults([]);
        setHasData(false);
        onClose();
    };

    const getDaysInMonth = (year, month) => {
        return new Date(year, month, 0).getDate();
    };

    const getDayName = (year, month, day) => {
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', { weekday: 'short' });
    };

    const generateCalendarDisplay = () => {
        if (!calendarResults.length) return { workerTypes: [], dates: [], attendanceData: {}, shifts: [] };

        const year = parseInt(calendarData.Year);
        const month = parseInt(calendarData.Month);
        const daysInMonth = getDaysInMonth(year, month);
        const shifts = [...new Set(calendarResults.map(item => item.displayShiftName))];

        const workerTypes = [...new Set(calendarResults.map(item => item.HkWrkTypeName))];

        const dates = [];
        for (let day = 1; day <= daysInMonth; day++) {
            dates.push({
                day: day,
                dayName: getDayName(year, month, day)
            });
        }

        const attendanceData = {};

        shifts.forEach(shift => {
            attendanceData[shift] = {};
            workerTypes.forEach(type => {
                attendanceData[shift][type] = {};
                dates.forEach(dateObj => {
                    attendanceData[shift][type][dateObj.day] = 0;
                });
            });
        });

        calendarResults.forEach(item => {
            const date = parseInt(item.TargetDate?.split('-')[2] || item.TargetDate?.split('T')[0]?.split('-')[2]);
            const shiftName = item.displayShiftName;
            const workerType = item.HkWrkTypeName;

            if (date && attendanceData[shiftName] && attendanceData[shiftName][workerType]) {
                attendanceData[shiftName][workerType][date] = item.TgHkTotal || 0;
            }
        });

        return {
            workerTypes,
            dates,
            attendanceData,
            shifts
        };
    };


    const calendarDataDisplay = generateCalendarDisplay();
    const tableCellStyles = {
        padding: '1px 2px',
        margin: 0,
        border: '1px solid #e0e0e0',
        fontSize: '0.65rem',
        lineHeight: '1',
        minWidth: '28px',
        maxWidth: '30px',
        width: '30px',
        textAlign: 'center',
        height: '32px',
        '&.MuiTableCell-head': {
            fontWeight: 'bold',
            backgroundColor: '#e3f2fd',
        }
    };

    const stickyTableCellStyles = {
        ...tableCellStyles,
        position: 'sticky',
        left: 0,
        zIndex: 3,
        minWidth: '100px',
        width: '100px',
        backgroundColor: '#e3f2fd',
        borderRight: '2px solid #ddd'
    };

    const stickyBodyCellStyles = {
        ...tableCellStyles,
        position: 'sticky',
        left: 0,
        zIndex: 2,
        minWidth: '100px',
        width: '100px',
        backgroundColor: 'inherit',
        borderRight: '2px solid #ddd',
        fontSize: '0.7rem'
    };

    const totalTableWidth = 100 + (calendarDataDisplay.dates.length * 30);
    const handlePrint = () => {
    if (!hasData || calendarDataDisplay.dates.length === 0) {
        toast.error('No data to print');
        return;
    }

    const printContent = document.createElement('div');

    printContent.innerHTML = `
        <div style="padding: 10px; font-family: Arial, sans-serif; font-size: 12px;">
            <h2 style="text-align: center; margin-bottom: 15px; font-size: 18px;">MenPower Attendance</h2>
            <div style="margin-bottom: 10px; line-height: 1.4;">
                <strong>Property:</strong> ${dropdownData.find(item => item.id === calendarData.Property)?.name || 'N/A'} | 
                <strong>Month:</strong> ${getMonthName(calendarData.Month)} | 
                <strong>Year:</strong> ${calendarData.Year} |
                <strong>Shifts:</strong> ${selectedShifts.map(shiftId => shiftData.find(shift => shift.id === shiftId)?.name).join(', ')}
            </div>
            ${calendarDataDisplay.shifts.map(shift => `
                <div style="margin-bottom: 20px; page-break-inside: avoid;">
                    <h3 style="background-color: #e3f2fd; padding: 5px; margin-bottom: 8px; font-size: 14px;">${shift}</h3>
                    <table border="1" cellpadding="2" cellspacing="0" style="border-collapse: collapse; width: 100%; font-size: 10px; table-layout: fixed;">
                        <thead>
                            <tr style="background-color: #f5f5f5;">
                                <th style="padding: 3px; text-align: left; width: 120px; min-width: 120px; max-width: 120px; word-wrap: break-word;">Worker Type</th>
                                ${calendarDataDisplay.dates.map(dateObj => `
                                    <th style="padding: 2px; text-align: center; width: 28px; min-width: 28px; max-width: 28px;">
                                        <div style="font-weight: bold;">${dateObj.day}</div>
                                        <div style="font-size: 8px; color: #666;">${dateObj.dayName}</div>
                                    </th>
                                `).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${calendarDataDisplay.workerTypes.map(workerType => `
                                <tr>
                                    <td style="padding: 3px; font-weight: bold; width: 120px; min-width: 120px; max-width: 120px; word-wrap: break-word;">${workerType}</td>
                                    ${calendarDataDisplay.dates.map(dateObj => {
                                        const value = calendarDataDisplay.attendanceData[shift]?.[workerType]?.[dateObj.day] || 0;
                                        return `<td style="padding: 2px; text-align: center; color: ${value > 0 ? 'green' : 'red'}; font-weight: bold;">${value}</td>`;
                                    }).join('')}
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>
            `).join('')}
        </div>
    `;

    const printWindow = window.open('', '_blank', 'width=auto,height=800');
    
    printWindow.document.write(`
        <html>
            <head>
                <title>Attendance Calendar - ${dropdownData.find(item => item.id === calendarData.Property)?.name || 'Property'} - ${getMonthName(calendarData.Month)} ${calendarData.Year}</title>
                <style>
                    body { 
                        margin: 0; 
                        padding: 10px; 
                        font-family: Arial, sans-serif; 
                        font-size: 12px;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 2px;
                    }
                    @media print {
                        body { 
                            margin: 0; 
                            padding: 10px;
                            font-size: 10px;
                        }
                        .no-print { display: none; }
                        table { 
                            page-break-inside: auto;
                            font-size: 9px;
                        }
                        tr { page-break-inside: avoid; }
                        h2 { font-size: 16px; }
                        h3 { font-size: 12px; }
                    }
                    @page {
                        size: landscape;
                        margin: 10mm;
                    }
                </style>
            </head>
            <body>
                ${printContent.innerHTML}
                <script>
                    window.onload = function() {
                        setTimeout(function() {
                            window.print();
                            setTimeout(function() {
                                window.close();
                            }, 500);
                        }, 250);
                    };
                </script>
            </body>
        </html>
    `);
    
    printWindow.document.close();
};
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '8px',
                    overflow: 'hidden',
                    maxHeight: '90vh',
                    width: '95vw'
                }
            }}
        >
            <DialogTitle
                sx={{
                    backgroundColor: '#f5f5f5',
                    borderBottom: '1px solid #e0e0e0',
                    padding: '8px 12px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}
            >
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Attendance Calendar
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                        padding: '4px'
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ padding: '16px' }}>
                <Grid container spacing={1} sx={{ my: 1 }}>
                    <Grid item xs={12} md={2.5}>
                        <FormControl variant="filled" fullWidth size="small" className="custom-textfield">
                            <InputLabel id="calendar-property-label">Property</InputLabel>
                            <Select
                                labelId="calendar-property-label"
                                id="Property"
                                name="Property"
                                value={calendarData.Property}
                                onChange={handleCalendarInputChange}
                            >
                                {dropdownData.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl variant="filled" fullWidth size="small" className="custom-textfield">
                            <InputLabel id="shift-label">Select Shifts</InputLabel>
                            <Select
                                labelId="shift-label"
                                id="Shift"
                                name="Shift"
                                multiple
                                value={selectedShifts}
                                onChange={handleShiftChange}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip
                                                key={value}
                                                label={shiftData.find(shift => shift.id === value)?.name || value}
                                                size="small"
                                            />
                                        ))}
                                    </Box>
                                )}
                            >
                                {shiftData.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        <Checkbox checked={selectedShifts.indexOf(item.id) > -1} size="small" />
                                        <Typography sx={{ fontSize: '0.8rem' }}>{item.name}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <FormControl variant="filled" fullWidth size="small" className="custom-textfield">
                            <InputLabel id="calendar-month-label">Month</InputLabel>
                            <Select
                                labelId="calendar-month-label"
                                id="Month"
                                name="Month"
                                value={calendarData.Month}
                                onChange={handleCalendarInputChange}
                            >
                                {monthOptions.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={2}>
                        <FormControl variant="filled" fullWidth size="small" className="custom-textfield">
                            <InputLabel id="calendar-year-label">Year</InputLabel>
                            <Select
                                labelId="calendar-year-label"
                                id="Year"
                                name="Year"
                                value={calendarData.Year}
                                onChange={handleCalendarInputChange}
                            >
                                {yearOptions.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={2.5} 
                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                    
                    >
                        <Button
                            variant="contained"
                            onClick={handleGetCalendarData}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={20} /> : 'Get Data'}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handlePrint}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={20} /> : 'Print'}
                        </Button>
                    </Grid>
                </Grid>

                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress size={30} />
                        <Typography variant="h6" sx={{ ml: 2, fontSize: '0.9rem' }}>
                            Loading calendar data...
                        </Typography>
                    </Box>
                ) : hasData && calendarDataDisplay.dates.length > 0 ? (
                    <Box sx={{ maxHeight: '500px' }}>
                        {calendarDataDisplay.shifts.map((shift, shiftIndex) => (
                            <Box key={shiftIndex} sx={{ mb: 3 }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        mb: 1,
                                        p: 0.5,
                                        backgroundColor: '#e3f2fd',
                                        borderRadius: 0.5,
                                        fontWeight: 'bold',
                                        fontSize: '0.9rem'
                                    }}
                                >
                                    {shift}
                                </Typography>

                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        '& .MuiTable-root': {
                                            minWidth: `${totalTableWidth}px`
                                        }
                                    }}
                                >
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={stickyTableCellStyles}>
                                                    Worker Type
                                                </TableCell>
                                                {calendarDataDisplay.dates.map((dateObj, index) => (
                                                    <TableCell
                                                        key={index}
                                                        align="center"
                                                        sx={tableCellStyles}
                                                    >
                                                        <Box sx={{ lineHeight: '1' }}>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '0.6rem' }}>
                                                                {dateObj.day}
                                                            </Typography>
                                                            <Typography sx={{ color: 'text.secondary', fontSize: '0.55rem' }}>
                                                                {dateObj.dayName}
                                                            </Typography>
                                                        </Box>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {calendarDataDisplay.workerTypes.map((workerType, workerIndex) => (
                                                <TableRow
                                                    key={workerIndex}
                                                    sx={{
                                                        '&:nth-of-type(odd)': {
                                                            backgroundColor: '#fafafa'
                                                        }
                                                    }}
                                                >
                                                    <TableCell sx={stickyBodyCellStyles}>
                                                        <Typography sx={{ fontSize: '0.7rem', fontWeight: 'bold' }}>
                                                            {workerType}
                                                        </Typography>
                                                    </TableCell>
                                                    {calendarDataDisplay.dates.map((dateObj, dateIndex) => (
                                                        <TableCell
                                                            key={dateIndex}
                                                            align="center"
                                                            sx={{
                                                                ...tableCellStyles,
                                                                color: calendarDataDisplay.attendanceData[shift]?.[workerType]?.[dateObj.day] > 0 ? 'green' : 'red',
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            {calendarDataDisplay.attendanceData[shift]?.[workerType]?.[dateObj.day] || 0}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        ))}
                    </Box>
                ) : hasData && calendarDataDisplay.dates.length === 0 ? (
                    <Paper sx={{ p: 2, textAlign: 'center', mt: 2 }}>
                        <Typography variant="h6" color="textSecondary" sx={{ fontSize: '0.9rem' }}>
                            No attendance data found for the selected criteria.
                        </Typography>
                    </Paper>
                ) : null}
            </DialogContent>

            <DialogActions sx={{ padding: '12px 16px', borderTop: '1px solid #e0e0e0' }}>
                <Button
                    onClick={handleReset}
                    variant="outlined"
                    color="secondary"
                    size="small"
                >
                    Reset
                </Button>
                <Button
                    onClick={handleClose}
                    variant="contained"
                    color="primary"
                    size="small"
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AttendenceCalender;